import { useQuery } from '@tanstack/react-query'
import { getTopEntities } from '../services/metricsApi'
import { SLOW } from '../utils/polling'

/**
 * Entities ranked by records processed in successful loads over the last `days` days.
 *
 * On SLOW: a week-long ranking moves when a load finishes, and every ETL job is manual-trigger.
 * `top` and `days` are both in the key by value and the function is called through a closure, so
 * the key and the request move together and a heading can never describe a window the cached
 * answer was not fetched for.
 *
 * The key is `['observatory', 'topEntities', top, days]` — the SignalR hub invalidates by the
 * `['observatory', 'topEntities']` prefix when a load completes.
 */
export function useTopEntities(top: number, days: number) {
  return useQuery({
    queryKey: ['observatory', 'topEntities', top, days],
    queryFn: () => getTopEntities(top, days),
    refetchInterval: SLOW,
  })
}
